import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class BuSelectionGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const selectedBU = sessionStorage.getItem('selectedBU');
    
    if (selectedBU) {
      return true;
    } else {
      console.log('[BuSelectionGuard] No BU selected, redirecting to /wells');
      this.router.navigate(['/wells']);
      return false;
    }
  }
}
